module.exports = __webpack_public_path__ + "static/words-are-my-matter-074e6ba0f0cc12ca41ad7ad4a8a474b9.jpg";